import React from 'react';
import { View } from 'react-native';
import { cn as dsCn } from '@vidahealth/vida-ds';

import { useDsEnabled } from '../contexts/DesignSystem';
import { cn } from '../utils/cn';

interface ProgressBarProps {
  strength: number; // 0-100
  hasError: boolean;
  testID?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ strength, hasError, testID }) => {
  const dsEnabled = useDsEnabled();
  const merge = dsEnabled ? dsCn : cn;
  const fill = dsEnabled
    ? hasError ? 'bg-status-warning' : 'bg-status-success'
    : hasError ? 'bg-login-gold-50' : 'bg-login-green-50';

  return (
    <View
      className={merge(
        'h-2 w-full overflow-hidden mt-2',
        dsEnabled ? 'rounded-full bg-wash-subtle' : 'bg-login-gray-10 rounded'
      )}
      testID={testID}
    >
      <View className={merge('h-full', dsEnabled ? 'rounded-full' : 'rounded', fill)} style={{ width: `${strength}%` }} />
    </View>
  );
};
